export default "__VITE_ASSET__lSzQMY2M__"